module.exports = __webpack_public_path__ + "static/media/teller.a58e306b.svg";